import React, { useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import moment from "moment-timezone";

import formatLeadOrigin from "../../helpers/lead-origin-formatter";

const LeadHeader = (props) => {
  const { lead } = props;

  const history = useHistory();

  const handleGoBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/leads");
    }
  }, [history]);

  return (
    <div id="page-header" className="trip-header">
      <div className="back-button-container">
        <div onClick={handleGoBack} className="back-button base-button icon-button evo-blue mr-10">
          <span className="material-icons">chevron_left</span>
        </div>
      </div>

      <div id="page-title-container">
        <p className="owner-name">{lead.assigneeId ? lead.assigneeName : "Unassigned"}</p>
        <p className="created-on">
          Created
          on {moment(lead.createdAt).format("MMMM Do, YYYY")} | {formatLeadOrigin(lead.leadOrigin, lead)} | {lead.appUser?.id ? "Yes" : "No"}
        </p>
        {lead.prospect && (
          <h1 className="page-title">
            {lead.prospect?.firstName} {lead.prospect?.lastName}&nbsp;

            <span>
              <Link className="text-transform-none" to={`/prospects/${lead.prospect._id}`} target="_blank" rel="noopener noreferrer">
                (view prospect)
              </Link>
            </span>

            <br/>

            {lead.itineraryDetails && (
              <span>
                {
                  lead.itineraryDetails.tripType === 2 ?
                    `${moment(lead.itineraryDetails.departureDate).format("M/D/YY")}-${moment(lead.itineraryDetails.returnDate).format("M/D/YY")} ${lead.itineraryDetails.departureAirportCode}-${lead.itineraryDetails.arrivalAirportCode}` :
                    lead.itineraryDetails.rawLegData?.length > 1 ?
                      `${moment(lead.itineraryDetails.departureDate).format("M/D/YY")} ${lead.itineraryDetails.departureAirportCode} Multi-Leg` :
                      `${moment(lead.itineraryDetails.departureDate).format("M/D/YY")} ${lead.itineraryDetails.departureAirportCode}-${lead.itineraryDetails.arrivalAirportCode}`
                }
              </span>
            )}

          </h1>
        )}
        {lead?.itineraryDetails?.isClickToFlyEligible && (
          <div className="ctf-badge">
            <span className="badge bg-primary">CTF Eligible</span>
          </div>
        )}
      </div>

      <div id="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/leads">Leads</Link>
          </li>
          <span className="material-icons">chevron_right</span>
          <li className="breadcrumb-item active">Lead - {lead?.firstName || ""} {lead?.lastName || ""}</li>
        </ol>
      </div>
    </div>
  );
};

export default LeadHeader;
